import React from "react";
import styled from "styled-components/macro";
import { DesktopDown, toRem } from "theme/Breakpoints";
import { MdChevronLeft } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  defaultHorizontalMargin,
  DefaultText,
} from "theme/GlobalElements";
import { colors } from "theme/Theme";
import { useSelector } from "react-redux";
import { RootState } from "store/rootReducer";
import { selectBreadcrumbTitle } from "./breadcrumbSlice";

interface BreadcrumbProps {}

const Breadcrumb: React.FC<BreadcrumbProps> = () => {
  const navigate = useNavigate();
  const title = useSelector((state: RootState) => selectBreadcrumbTitle(state));

  const goBack = () => {
    navigate(-1);
  };
  return title !== "" ? (
    <BreadcrumbContainer>
      <BreadcrumbWrapper>
        <DesktopDown>
          <Chevron backgroundColor={`${colors.lighter_blue}`} onClick={goBack}>
            <MdChevronLeft
              style={{
                width: 42,
                height: 42,
                color: "black",
                borderRight: "1px #e8e8e8 solid",
              }}
            />
          </Chevron>
        </DesktopDown>
        <BreadcrumbDataContainer>
          <Link to="/">
            <HomeText className="text-sm">Начало</HomeText>
          </Link>
          <Delimiter className="text-sm">/</Delimiter>
          <DefaultText className="text-sm">{title}</DefaultText>
        </BreadcrumbDataContainer>
      </BreadcrumbWrapper>
    </BreadcrumbContainer>
  ) : (
    <></>
  );
};

const BreadcrumbContainer = styled(Container)`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
  height: 50px;
`;
const BreadcrumbWrapper = styled.div`
  display: inline-flex;
  justify-content: space-between;
  height: 100%;
  width: 100%;
`;
export const Chevron = styled.div<{ backgroundColor?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: ${toRem(50)};
`;

const BreadcrumbDataContainer = styled.li`
  ${defaultHorizontalMargin};
  display: flex;
  flex-grow: 2;
  flex-flow: row nowrap;
  align-items: center;
  ::-webkit-scrollbar {
    /* Hide scrollbar for Chrome, Safari and Opera */
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  a {
    text-decoration: none;
  }
`;

const HomeText = styled(DefaultText)`
  color: ${colors.lighter_blue};
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  &:visited {
    color: ${colors.lighter_blue};
  }

  &:hover {
    color: ${colors.light_blue};
  }
`;
const Delimiter = styled.div`
  color: ${colors.darkest};
  margin: 0 10px;
`;

export default Breadcrumb;
